import * as actionTypes from '../Audit_action.types';
import * as api from '../audit_api_services/AttachmentDownload.api';

export const fetchAttachmentFileRequest = (data) => ({
    type: actionTypes.FETCH_ATTACHMENT_FILE_REQUEST,
    payload: data,
  });
  
  export const fetchAttachmentFileSuccess = (data) => ({
  type: actionTypes.FETCH_ATTACHMENT_FILE_SUCCESS,
  payload: data,
  });
  
  export const fetchAttachmentFileFailure = (error) => ({
  type: actionTypes.FETCH_ATTACHMENT_FILE_FAILURE,
  payload: error,
  });
  
  export const fetchAttachmentFile = (status,data) => {
    return async (dispatch) => {
      dispatch(fetchAttachmentFileRequest(data));
      try {
        const response = await api.AttachmentFile(status,data);
        dispatch(fetchAttachmentFileSuccess(response));
        return { success: true, message: response };
      } catch (error) {
        dispatch(fetchAttachmentFileFailure(error));
        return { success: false, message: error };
      }
    };
  };
  
export const downloadAttachmentFileRequest = () => ({
  type: actionTypes.DOWNLOAD_ATTACHMENT_FILE_REQUEST,
});

export const downloadAttachmentFileSuccess = (name) => ({
  type: actionTypes.DOWNLOAD_ATTACHMENT_FILE_SUCCESS,
  payload: name,
});

export const downloadAttachmentFileFailure = (error) => ({
  type: actionTypes.DOWNLOAD_ATTACHMENT_FILE_FAILURE,
  payload: error,
});

export const downloadAttachmentFile = (id,name) => {
  return async (dispatch) => {
    dispatch(downloadAttachmentFileRequest());
    try {
      const response = await api.downloadAttachmentFile(id,name);
      dispatch(downloadAttachmentFileSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(downloadAttachmentFileFailure(error));
      return { success: false, message: error };
    }
  };
};

export const deleteAttachmentFileRequest = () => ({
  type: actionTypes.DELETE_ATTACHMENT_FILE_REQUEST,
});

export const deleteAttachmentFileSuccess = (name) => ({
  type: actionTypes.DELETE_ATTACHMENT_FILE_SUCCESS,
  payload: name,
});

export const deleteAttachmentFileFailure = (error) => ({
  type: actionTypes.DELETE_ATTACHMENT_FILE_FAILURE,
  payload: error,
});

export const deleteAttachmentFile = (id,name) => {
  return async (dispatch) => {
    dispatch(deleteAttachmentFileRequest());
    try {
      const response = await api.deleteAttachmentFile(id,name);
      dispatch(deleteAttachmentFileSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(deleteAttachmentFileFailure(error));
      return { success: false, message: error };
    }
  };
};